import { PunctualityReportRepository } from '@src/main/modules/reports/punctuality/domain/punctuality-report.repository';
import {
  PunctualityReport,
  PunctualityReportCriteria,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const findPunctualityReportsByCriteria = async (
  repository: PunctualityReportRepository,
  criteria: PunctualityReportCriteria,
): Promise<PageResponse<PunctualityReport>> => await repository.findByCriteria(criteria);
